<div class="help-requests-container">
  <!-- Header -->
  <div class="header">
    <h1>Gestión de Casos de Ayuda</h1>
    <p class="subtitle" *ngIf="!loading">Total: {{ totalElements }} casos</p>
  </div>

  <!-- Error Message -->
  <mat-card *ngIf="error" class="error-card">
    <mat-icon color="warn">error</mat-icon>
    <span>{{ error }}</span>
  </mat-card>

  <!-- Loading Spinner -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Cargando casos...</p>
  </div>

  <!-- Cases Table -->
  <div *ngIf="!loading && !error" class="table-container">
    <table mat-table [dataSource]="cases" class="cases-table">
      
      <!-- Case Code Column -->
      <ng-container matColumnDef="caseCode">
        <th mat-header-cell *matHeaderCellDef>Código</th>
        <td mat-cell *matCellDef="let case">
          <div class="case-code-cell">
            <mat-icon>confirmation_number</mat-icon>
            <strong>{{ case.caseCode }}</strong>
          </div>
        </td>
      </ng-container>

      <!-- Origin Type Column -->
      <ng-container matColumnDef="originType">
        <th mat-header-cell *matHeaderCellDef>Origen</th>
        <td mat-cell *matCellDef="let case">
          <mat-chip [color]="getOriginTypeColor(case.originType)" selected>
            {{ case.originType }}
          </mat-chip>
        </td>
      </ng-container>

      <!-- Created At Column -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let case">
          {{ case.createdAt | date: 'dd/MM/yyyy HH:mm' }}
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="statusName">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let case">
          <span class="status-chip" [ngClass]="getStatusClass(case.statusName)">
            {{ case.statusName }}
          </span>
        </td>
      </ng-container>

      <!-- Chat Preview Column -->
      <ng-container matColumnDef="chatPreview">
        <th mat-header-cell *matHeaderCellDef>Mensaje</th>
        <td mat-cell *matCellDef="let case" class="preview-cell">
          <p>{{ case.chatPreview }}</p>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let case">
          <button mat-raised-button color="primary" (click)="viewCaseDetails(case.id)">
            <mat-icon>visibility</mat-icon>
            Ver Detalle
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
    </table>
  </div>

  <!-- Pagination -->
  <mat-paginator 
    *ngIf="!loading && cases.length > 0"
    [length]="totalElements"
    [pageSize]="pageSize"
    [pageIndex]="currentPage"
    [pageSizeOptions]="[5, 10, 25, 50]"
    (page)="onPageChange($event)"
    showFirstLastButtons>
  </mat-paginator>

  <!-- Files Modal -->
  <div *ngIf="selectedCaseWithFiles" class="modal-overlay" (click)="closeFilesModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2>
          <mat-icon>attach_file</mat-icon>
          Caso: {{ selectedCaseWithFiles.caseCode }}
        </h2>
        <div class="modal-header-actions">
          <button
            mat-stroked-button
            color="warn"
            *ngIf="!isCaseClosed(selectedCaseWithFiles)"
            [disabled]="updatingStatus"
            (click)="confirmCloseCase()">
            <mat-icon>lock</mat-icon>
            Cerrar caso
          </button>
          <button
            mat-stroked-button
            color="primary"
            *ngIf="isCaseClosed(selectedCaseWithFiles)"
            [disabled]="updatingStatus"
            (click)="confirmReopenCase()">
            <mat-icon>lock_open</mat-icon>
            Reabrir caso
          </button>
          <button mat-icon-button (click)="closeFilesModal()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="loadingFiles" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Cargando archivos...</p>
      </div>

      <div *ngIf="!loadingFiles" class="modal-body">
        <div class="detail-section">
          <h3>Información del Caso</h3>
          <div class="detail-grid">
            <div class="detail-item">
              <strong>Código:</strong>
              <span>{{ selectedCaseWithFiles.caseCode }}</span>
            </div>
            <div class="detail-item">
              <strong>Origen:</strong>
              <mat-chip [color]="getOriginTypeColor(selectedCaseWithFiles.originType)" selected>
                {{ selectedCaseWithFiles.originType }}
              </mat-chip>
            </div>
            <div class="detail-item">
              <strong>Fecha:</strong>
              <span>{{ selectedCaseWithFiles.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
            </div>
            <div class="detail-item">
              <strong>Estado:</strong>
              <span class="status-chip" [ngClass]="getStatusClass(selectedCaseWithFiles.statusName)">
                {{ selectedCaseWithFiles.statusName }}
              </span>
            </div>
          </div>
        </div>

        <div class="detail-section" *ngIf="selectedCaseWithFiles.userInfo">
          <h3>
            <mat-icon>person</mat-icon>
            Información del Usuario
          </h3>
          <div class="detail-grid">
            <div class="detail-item">
              <strong>Nombre:</strong>
              <span>{{ selectedCaseWithFiles.userInfo.firstName }} {{ selectedCaseWithFiles.userInfo.lastName }}</span>
            </div>
            <div class="detail-item">
              <strong>Email:</strong>
              <span>{{ selectedCaseWithFiles.userInfo.email }}</span>
            </div>
            <div class="detail-item">
              <strong>Teléfono:</strong>
              <span>{{ selectedCaseWithFiles.userInfo.phoneNumber }}</span>
            </div>
          </div>
        </div>

        <div class="detail-section">
          
          <div class="chat-conversation">
            <h4>
              <mat-icon>chat</mat-icon>
              Conversación
            </h4>
            <div class="chat-messages">
              <div *ngFor="let message of getConversationMessages(selectedCaseWithFiles); trackBy: trackByMessage"
                   class="chat-message"
                   [class.user-message]="isUserMessage(message.sender)"
                   [class.assistant-message]="isAssistantMessage(message.sender)"
                   [class.operator-message]="isOperatorMessage(message.sender)">
                <div class="message-header">
                  <span class="sender">{{ getSenderLabel(message.sender) }}</span>
                  <span class="timestamp">{{ formatTimestamp(message.timestamp) }}</span>
                </div>
                <div class="message-bubble">
                  <p>{{ message.text }}</p>
                </div>
              </div>
              <p *ngIf="getConversationMessages(selectedCaseWithFiles).length === 0" class="no-messages">
                Sin mensajes en la conversación.
              </p>
            </div>

            <!-- Caja de respuesta del operador -->
            <div class="reply-box">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Responder</mat-label>
                <textarea
                  matInput
                  [(ngModel)]="replyMessage"
                  [disabled]="isCaseClosed(selectedCaseWithFiles) || sendingReply"
                  rows="3"
                  placeholder="Escriba la respuesta para el usuario...">
                </textarea>
                <mat-hint *ngIf="isCaseClosed(selectedCaseWithFiles)">
                  El caso está cerrado. Reábralo para poder responder.
                </mat-hint>
              </mat-form-field>
              <button
                mat-raised-button
                color="primary"
                class="reply-button"
                [disabled]="isCaseClosed(selectedCaseWithFiles) || sendingReply || !replyMessage.trim()"
                (click)="sendReply()">
                <mat-icon>send</mat-icon>
                {{ sendingReply ? 'Enviando...' : 'Responder' }}
              </button>
            </div>
          </div>
        </div>

        <div class="detail-section" *ngIf="selectedCaseWithFiles.files && selectedCaseWithFiles.files.length > 0">
          <h3>
            <mat-icon>folder</mat-icon>
            Archivos Adjuntos ({{ selectedCaseWithFiles.files.length }})
          </h3>
          <div class="files-grid">
            <mat-card *ngFor="let file of selectedCaseWithFiles.files" class="file-card">
              <div class="file-icon">
                <mat-icon>{{ getFileIcon(file.extension) }}</mat-icon>
              </div>
              <div class="file-info">
                <h4>{{ file.fileName }}</h4>
                <span class="file-extension">.{{ file.extension }}</span>
              </div>
              <button mat-raised-button color="primary" (click)="openFile(file)">
                <mat-icon>open_in_new</mat-icon>
                Abrir
              </button>
            </mat-card>
          </div>
        </div>

        <div class="detail-section" *ngIf="!selectedCaseWithFiles.files || selectedCaseWithFiles.files.length === 0">
          <p class="no-files">
            <mat-icon>info</mat-icon>
            No hay archivos adjuntos en este caso
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
